import { XMarkIcon } from "@heroicons/react/24/outline";
import React, { useEffect, useState } from "react";
import { useStore } from "../../store";

export const NotificationsPanel: React.FC = () => {
  const { showNotifications, closeNotifications } = useStore();

  const [xTranslate, setXTranslate] = useState(100);
  useEffect(() => {
    setXTranslate(showNotifications ? 0 : 100);
  }, [showNotifications]);

  const handleClose = () => {
    setXTranslate(100);
    closeNotifications();
  };

  // const panelAlerts = useStore(useShallow(selectPanelAlerts));
  // const [tick, setTick] = useState(0);

  // // local ticker to recompute freshness styles
  // useEffect(() => {
  //   if (!showNotifications) return;
  //   const interval = setInterval(() => setTick((t) => t + 1), 1000);
  //   return () => clearInterval(interval);
  // }, [showNotifications]);

  // if (!showNotifications) return null;

  return (
    <div
      className="absolute right-0 top-0 h-full bg-crane-dark border-l border-crane-darker w-[calc(100%-712px-32px)] transition-transform duration-300"
      style={{ transform: `translateX(${xTranslate}%)` }}
    >
      <div className="flex items-center justify-between p-4 border-b border-crane-darker">
        <h2 className="crane-text-body-xl font-semibold">Notification list</h2>
        <button
          onClick={handleClose}
          className="p-1 hover:bg-crane-darker rounded"
        >
          <XMarkIcon className="w-6 h-6 text-crane-light-gray" />
        </button>
      </div>
      <div className="p-2 overflow-y-auto h-[calc(100%-112px)]">
        <div className="text-center text-crane-gray p-8">
          This feature is not yet implemented.
        </div>
      </div>
    </div>
  );

  // return (
  //   <div className="absolute right-0 top-0 h-full bg-crane-dark border-l border-crane-darker w-[calc(100%-712px-32px)] transition-transform duration-300">
  //     <div className="flex items-center justify-between p-4 border-b border-crane-darker">
  //       <h2 className="crane-text-body-xl font-semibold">Notification list</h2>
  //       <button
  //         onClick={closeNotifications}
  //         className="p-1 hover:bg-crane-darker rounded"
  //       >
  //         <XMarkIcon className="w-6 h-6 text-crane-light-gray" />
  //       </button>
  //     </div>

  //     <div className="p-4 space-x-2 flex">
  //       {["all", "error", "warning", "info", "critical"].map((filter) => (
  //         <button
  //           key={filter}
  //           onClick={() => setNotificationsFilter(filter as any)}
  //           className={`px-3 py-1 rounded text-sm border ${
  //             notificationsFilter === filter
  //               ? "bg-crane-darker border-crane-light-gray"
  //               : "border-crane-darker text-crane-gray hover:border-crane-gray"
  //           }`}
  //         >
  //           {filter.charAt(0).toUpperCase() + filter.slice(1)}
  //         </button>
  //       ))}
  //     </div>

  //     <div className="p-2 overflow-y-auto h-[calc(100%-112px)]">
  //       {panelAlerts.length === 0 ? (
  //         <div className="text-center text-crane-gray p-8">
  //           No notifications
  //         </div>
  //       ) : (
  //         <ul className="space-y-3">
  //           {panelAlerts.map((alert) => {
  //             const definition =
  //               alertDefinitions[
  //                 alert.definitionId as keyof typeof alertDefinitions
  //               ];
  //             const alertType = definition?.type || "info";
  //             const alertTitle = definition?.title || "Unknown Alert";
  //             const alertMessage =
  //               definition?.message || "No message available";
  //             const fresh = isAlertFresh(alert);

  //             return (
  //               <li
  //                 key={alert.id}
  //                 className={`rounded border p-3 ${
  //                   alert.acknowledged
  //                     ? "border-crane-darker bg-crane-darker/30 opacity-60"
  //                     : fresh && alertType === "warning"
  //                     ? "border-crane-amber bg-crane-amber-dark/20"
  //                     : fresh && alertType === "error"
  //                     ? "border-crane-accent bg-crane-accent-dark/20"
  //                     : fresh && alertType === "critical"
  //                     ? "border-crane-red bg-crane-red-dark/20"
  //                     : fresh && alertType === "info"
  //                     ? "border-crane-blue-gray bg-crane-dark"
  //                     : "border-crane-darker bg-crane-dark"
  //                 }`}
  //               >
  //                 <div className="flex items-start justify-between">
  //                   <div>
  //                     <div className="crane-text-body-md font-medium">
  //                       {alertTitle}
  //                     </div>
  //                     <div className="text-sm text-crane-light-gray mt-1">
  //                       {alertMessage}
  //                     </div>
  //                     <div className="text-xs text-crane-gray mt-1">
  //                       {alert.timestamp}
  //                     </div>
  //                   </div>
  //                   <div className="flex space-x-2">
  //                     {!alert.acknowledged && (
  //                       <button
  //                         onClick={() => acknowledgeAlert(alert.id)}
  //                         className="crane-button-success px-2 py-1 text-xs"
  //                       >
  //                         Acknowledge
  //                       </button>
  //                     )}
  //                     <button
  //                       onClick={() => {
  //                         console.log("View details:", alert.id);
  //                         try {
  //                           markAlertInteracted(alert.id);
  //                         } catch {}
  //                       }}
  //                       className="crane-button-secondary px-2 py-1 text-xs"
  //                     >
  //                       Details
  //                     </button>
  //                   </div>
  //                 </div>
  //               </li>
  //             );
  //           })}
  //         </ul>
  //       )}
  //     </div>
  //   </div>
  // );
};
